import styled from 'styled-components';
export var Svg = styled.svg.withConfig({
  componentId: "sc-gr4cf2-0"
})(["display:inline-block;vertical-align:middle;margin-left:8px;transform:rotate(", "deg);transition:transform 0.2s ease-in;"], function (_ref) {
  var active = _ref.active;
  return active ? 180 : 0;
});